import { adminHttpClient } from '../../commons/adminHttpClient'
import OrderedPageFilter from '../../commons/orderedPageFilter'
import PagedList from '../../commons/PagedList'

export interface PagedMigrationQueue extends PagedList<MigrationQueue> {}

export interface MigrationQueue {
  id: string
  companyId: string
  status: MigrationStatus
  migrationDate: Date
}

export enum MigrationStatus {
  Queued = 0,
  Started = 1,
  Completed = 2,
  Failed = 3,
}

export interface MigrationQueueFilter extends OrderedPageFilter {
  companyId: string
  migrationDate: Date
}

const getMigrationQueue = (filter: MigrationQueueFilter): Promise<any> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 20,
    orderColumn: 'createdAt',
    orderDescending: true,
  }

  return adminHttpClient.get('/csi/MigrationQueue', filter)
}

export default getMigrationQueue
